module.exports = __webpack_public_path__ + "assets/img/bigcat6_good.b3195466.png";